import React from 'react';
import styled from 'styled-components';

import { reduxConnect } from '../../common';
import { dataLayer } from '@weatherbug/common';
import { travelLocations } from './travelLocations';
import { CityCard } from './cityCard';
import { smallMediaQuery, mediumMediaQuery, largeMediaQuery } from '../../common/utilities/sizeHelpers';
import { LifePageContentTitle } from '../common/life/lifePageContentTitle';
import { translate } from  '../../common/translation/translate';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';
import { DisplayAdWidget } from '../ads/displayAdWidget.jsx';
import { DisplayAdUnit } from '../../containers/ads/displayAdUnitContainer';

const { getHourlyForecastByLatLon, getDailyForecastByLatLon, getCurrentStationObsByLatLon } = dataLayer.actions;
const mapStoreStateToProps = (storeState) => {
    const appState = storeState.appState.appState || {};
    const {
        authId,
        secret,
        forecastBaseUrl,
        forecastIconResourceList,
        forecastIconSize,
        forecastIconSet,
        contentMgmtBaseUrl,
        obsBaseUrl,
        stdParameters,
        user
    } = appState;

    const windSpeedUnit = user?.WindUnit;
    const pressureUnit = user?.PressureUnit;
    const tempUnit = user?.Units;
    const lengthUnit = tempUnit ? tempUnit : 1;

    return {
        authId,
        secret,
        obsBaseUrl,
        forecastBaseUrl,
        forecastIconResourceList,
        forecastIconSize,
        forecastIconSet,
        contentMgmtBaseUrl,
        stdParameters,
        windSpeedUnit,
        pressureUnit,
        tempUnit,
        lengthUnit
    };
};

const mapDispatchToProps = {
    getHourlyForecastByLatLon,
    getDailyForecastByLatLon,
    getCurrentStationObsByLatLon
};

const Travel = withScreenSize(reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({
    authId,
    secret,
    obsBaseUrl,
    forecastBaseUrl,
    forecastIconResourceList,
    forecastIconSize,
    forecastIconSet,
    contentMgmtBaseUrl,
    stdParameters,
    windSpeedUnit,
    pressureUnit,
    tempUnit,
    lengthUnit,
    getHourlyForecastByLatLon,
    getDailyForecastByLatLon,
    getCurrentStationObsByLatLon,
    isDesktop,
    isMobile
}) => {
    return (
        <>
            {!isDesktop
                && <MobileBannerAd>
                    <DisplayAdUnit
                        width={320}
                        height={50}
                        slotId={'life_travel_mobile_top_banner_x83'}
                    />
                </MobileBannerAd>
            }
            <LifePageContentTitle pageTitle={translate('travel')} showTitleAsH1={true} />
            <MainContainer>
                <StoriesContainer>
                    <CardList>
                        {travelLocations.map((city, i) => {
                            return (
                                <>
                                    <CityCard
                                        key={city.CityId}
                                        city={city}
                                        authId={authId}
                                        secret={secret}
                                        obsBaseUrl={obsBaseUrl}
                                        forecastBaseUrl={forecastBaseUrl}
                                        forecastIconResourceList={forecastIconResourceList}
                                        forecastIconSize={forecastIconSize}
                                        forecastIconSet={forecastIconSet}
                                        contentMgmtBaseUrl={contentMgmtBaseUrl}
                                        stdParameters={stdParameters}
                                        windSpeedUnit={windSpeedUnit}
                                        pressureUnit={pressureUnit}
                                        tempUnit={tempUnit}
                                        lengthUnit={lengthUnit}
                                        getHourlyForecastByLatLon={getHourlyForecastByLatLon}
                                        getDailyForecastByLatLon={getDailyForecastByLatLon}
                                        getCurrentStationObsByLatLon={getCurrentStationObsByLatLon}
                                    />
                                    {i === 2 && isMobile && <StoriesAdWrapper>
                                        <DisplayAdUnit 
                                            slotId={'life_travel_mobile_stories_x11'}
                                            height={250}
                                            width={300}
                                        />
                                    </StoriesAdWrapper>}
                                </>
                                
                            );
                        })}
                    </CardList>
                </StoriesContainer>
                {isDesktop
                    && <AdContainer>
                        <DisplayAdUnit
                            slotId={'life_travel_top_right_x16'}
                            height={600}
                            width={300}
                        />
                    </AdContainer>
                }
            </MainContainer>
        </>
    );
}));

Travel.displayName = 'Travel';

const MainContainer = styled.div`
    display: flex;
    flex-direction: row;
    @media ${largeMediaQuery} {
        margin-right: 5px;
    }
`;

const MobileBannerAd = styled.div`
    margin-bottom: 20px;
`;

const StoriesContainer = styled.div`
    @media ${largeMediaQuery} {
        width: calc(100% - 316px);
    }

    @media ${mediumMediaQuery} {
        margin-bottom: 10px;
    }
`;

const CardList = styled.ul`
    padding-left: 0;
    padding-top: 0;
    white-space: normal;

    @media ${smallMediaQuery} {
        margin: 0 0 4px 0;
    }
`;

const AdContainer = styled.div`
    padding: 5px 0 0 16px;
`;

const StoriesAdWrapper = styled.div`
    margin: 20px 0 10px 0;
`;

export { Travel as default };
